import React from 'react';
import './style/CGVCGU.css';
import { useTranslation } from 'react-i18next';

function CgvCgu() {
  const { t } = useTranslation();

  return (
    <div className="terms-page">
      <div className="terms-box">
        <h1>{t('cgvcgu.titleCgu')}</h1>

        {Object.keys(t('cgvcgu.cgu', { returnObjects: true })).map((key) => {
          const section = t(`cgvcgu.cgu.${key}`, { returnObjects: true });
          return (
            <section key={`cgu-${key}`}>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
              {Array.isArray(section.list) && (
                <ul>
                  {section.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          );
        })}

        <hr />

        <h1>{t('cgvcgu.titleCgv')}</h1>

        {Object.keys(t('cgvcgu.cgv', { returnObjects: true })).map((key) => {
          const section = t(`cgvcgu.cgv.${key}`, { returnObjects: true });
          return (
            <section key={`cgv-${key}`}>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
              {Array.isArray(section.list) && (
                <ul>
                  {section.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}

export default CgvCgu;
